<k-area-blocker [showLoader]="_isBusy" [message]="_blockerMessage">
  <div #preview class="kPreviewAndEmbed">
    <form [formGroup]="_previewForm" novalidate>
      <div class="kHeader">
        <div>
          <i class="kIconclose_small kClose" (click)="close()"></i>
          <span class="kTitle">{{ _title }}</span>
        </div>
        <div class="kSelectPlayer">
          <span>{{ 'applications.embed.selectPlayer' | translate }}</span>
          <p-dropdown
            #playersDropdown
            [options]="_players"
            formControlName="selectedPlayer"
            [filter]="true"
            filterBy="label,value.uiConf.id"
          >
            <ng-template let-item pTemplate="selectedItem">
              <div class="playerItem selectedPlayer">
                <div [class]="'playerIcon v' + item.value.version"></div>
                <span>{{ item.label }}</span>
              </div>
            </ng-template>
            <ng-template let-item pTemplate="item">
              <div class="playerItem">
                <div [class]="'playerIcon v' + item.value.version"></div>
                <span>{{ item.label }}</span>
                <i class="check kIconcheck_small"></i>
              </div>
            </ng-template>
          </p-dropdown>
          <i #settingsBtn class="kIcongear kPlayerSettings"></i>
        </div>
        <i
          class="kIconShare kToggleParamsIcon"
          [class.kHighlight]="!_showEmbedParams"
          (click)="toggleEmbedParams()"
        ></i>
      </div>

      <div class="kPreview">
        <div class="kPreviewContainer">
          <iframe
            #previewIframe
            *ngIf="_showPlayer"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            allowFullScreen
            webkitallowfullscreen
            mozallowfullscreen
          ></iframe>
        </div>
        <div class="kPreviewParams" [style.maxWidth]="_showEmbedParams ? '450px' : '0px'">
          <div class="kParamsContainer">
            <span class="kTitle">{{ media?.name }}</span>
            <ng-container *ngIf="_showEmberCode">
              <div class="kSection kAlignTop">
                <span class="kCol">{{ 'applications.embed.embedCode' | translate }}</span>
                <textarea readonly #code pInputTextarea>{{ _generatedCode }}</textarea>
              </div>
              <div class="kSection kRow">
                <button
                  pButton
                  type="button"
                  class="kButtonBranded kCopyCode"
                  (click)="copyEmbedCode(code)"
                  label="{{ 'applications.embed.copy' | translate }}"
                ></button>
              </div>
            </ng-container>
            <div class="kSection kAlignTop kRow">
              <span class="kCol">{{ 'applications.embed.view' | translate }}</span>
              <a href="{{ _shortLink }}" target="_blank">{{ _shortLink }}</a>
            </div>
            <div class="kSection kRow kAlignTop">
              <span class="kCol">{{ 'applications.embed.qr' | translate }}</span>
              <qrcode
                *ngIf="_shortLink"
                [qrdata]="_shortLink"
                [margin]="0"
                [width]="80"
                [errorCorrectionLevel]="'M'"
              ></qrcode>
            </div>

            <div class="kSection kRow">
              <a (click)="toggleAdvanced()">{{ 'applications.embed.advanced' | translate }}</a>
              <i class="kAdvancedArrow kIcondropdown_arrow_right" [class.kArrowDown]="_showAdvanced"></i>
            </div>

            <div class="kAdvanced" [style.maxHeight]="_showAdvanced ? '250px' : '0px'">
              <div class="kSection kRow">
                <div class="kCol">
                  <span>{{ 'applications.embed.embedType' | translate }}</span>
                  <i #helpTip class="kIconhelp_full kHelpTip"></i>
                </div>
                <p-dropdown [options]="_embedTypes" formControlName="selectedEmbedType"></p-dropdown>
              </div>
              <div class="kSection kRow kAlignTop" [class.kHidden]="_selectedPlayerVersion === 3">
                <span class="kCol">{{ 'applications.embed.seo' | translate }}</span>
                <p-inputSwitch formControlName="seo"></p-inputSwitch>
              </div>
              <div class="kSection kRow kAlignTop">
                <span class="kCol">{{ 'applications.embed.https' | translate }}</span>
                <p-inputSwitch formControlName="secured"></p-inputSwitch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</k-area-blocker>

<kPopupWidget
  data-aid="sortSettings"
  [closeOnResize]="true"
  [popupWidth]="360"
  [popupHeight]="254"
  [targetRef]="settingsBtn"
  [appendTo]="preview"
  [targetOffset]="{ x: -330, y: 30 }"
  [closeBtnInside]="true"
>
  <div class="kSettings">
    <span>{{ 'applications.embed.settings' | translate | uppercase }}</span>
    <p-radioButton
      name="layersSortBy"
      value="name"
      label="{{ 'applications.embed.name' | translate }}"
      [(ngModel)]="_playersSortBy"
      (onClick)="updatePlayersSort('name')"
    ></p-radioButton>
    <p-radioButton
      name="layersSortBy"
      value="version"
      label="{{ 'applications.embed.version' | translate }}"
      [(ngModel)]="_playersSortBy"
      (onClick)="updatePlayersSort('version')"
    ></p-radioButton>
    <p-radioButton
      name="layersSortBy"
      value="createdAt"
      label="{{ 'applications.embed.added' | translate }}"
      [(ngModel)]="_playersSortBy"
      (onClick)="updatePlayersSort('createdAt')"
    ></p-radioButton>
    <p-radioButton
      name="layersSortBy"
      value="updatedAt"
      label="{{ 'applications.embed.updated' | translate }}"
      [(ngModel)]="_playersSortBy"
      (onClick)="updatePlayersSort('updatedAt')"
    ></p-radioButton>
  </div>
</kPopupWidget>

<kPopupWidget
  data-aid="helpTip"
  [popupWidth]="500"
  [targetRef]="helpTip"
  [appendTo]="preview"
  [targetOffset]="{ x: -250, y: 20 }"
  [closeBtn]="false"
>
  <div class="kTooltip">
    <div class="kHelpTitle">
      <i class="kIconlife_donut"></i>
      <span>{{ 'applications.embed.embedType' | translate }}</span>
    </div>
    <div class="kTooltipContent">
      <span>{{ 'applications.embed.helpTip1' | translate }}</span>
      <a [hidden]="!_embedTypesHelpExists" (click)="openLink('embedTypes')">
        {{ 'applications.embed.helpTip2' | translate }}</a
      >
      <span [hidden]="!_embedTypesHelpExists"> {{ 'applications.embed.helpTip3' | translate }}</span>
    </div>
    <div class="kTooltipContent">
      <span>{{ 'applications.embed.helpTip4' | translate }}</span>
      <span [hidden]="!_deliveryProtocolsHelpExists">{{ 'applications.embed.helpTip5' | translate }}</span>
      <a [hidden]="!_deliveryProtocolsHelpExists" (click)="openLink('deliveryProtocols')">
        {{ 'applications.embed.helpTip6' | translate }}</a
      >
    </div>
  </div>
</kPopupWidget>
